/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useState, useEffect } from 'react';
import { useDominantSpeaker } from '../../../../hooks/videoProvider/useDominantSpeaker';

export interface UseDominantSpeakerParticipant {
  dominantSpeakerParticipant: VideoProvider.IParticipant | null;
}

export const useDominantSpeakerParticipant = (
  nonPinnedParticipants: VideoProvider.IParticipant[],
): UseDominantSpeakerParticipant => {
  const dominantSpeaker = useDominantSpeaker();
  const [dominantSpeakerParticipant, setDominantSpeakerParticipant] = useState<VideoProvider.IParticipant | null>(null);
  useEffect(() => {
    const shouldSetInitialDominantSpeaker = !!dominantSpeaker && !dominantSpeakerParticipant;
    const shouldUpdateNewDominantSpeaker = !!dominantSpeaker && dominantSpeaker.sid !== dominantSpeakerParticipant?.sid;
    if (shouldSetInitialDominantSpeaker || shouldUpdateNewDominantSpeaker) {
      const newDominantSpeakerParticipant = nonPinnedParticipants.find(
        participant => participant.sid === dominantSpeaker?.sid,
      );
      if (!!newDominantSpeakerParticipant) {
        setDominantSpeakerParticipant(newDominantSpeakerParticipant);
      }
    }
  }, [dominantSpeaker, dominantSpeakerParticipant, nonPinnedParticipants]);

  return { dominantSpeakerParticipant };
};
